import { defineStore } from "pinia";

export interface Menu {
  icon: string;
  title: string;
  pageName?: string;
  subMenu?: Menu[];
  ignore?: boolean;
  permiso?: Permisos;
  soloAdmin?: boolean;
  /** Solo cuentas @fixed.uy o @atiendo.cloud (ver `puedeVerLogAccionesInterno`). */
  soloMailsInternos?: boolean;
}

export interface SideMenuState {
  menu: Array<Menu | "divider">;
}

import {
  puedeAccederModulo,
  isAdmin,
  puedeVerLogAccionesInterno
} from "../utils/permisos";
import { Permisos } from "@fixeduy/restaurantestypes";

export const useSideMenuStore = defineStore("sideMenu", {
  state: (): SideMenuState => {
    return { menu: [] as Array<Menu | "divider"> };
  },
  actions: {
    setUpdatedMenu(menuUpdated: Array<Menu | "divider">) {
      this.menu = menuUpdated;
    },
    regenerarMenu() {
      const menuTodos: Array<Menu | "divider"> = [
        { icon: "Home", pageName: "home", title: "Inicio", soloAdmin: true },
        {
          icon: "PlayIcon",
          pageName: "pedidosLive",
          title: "Comandas",
          permiso: Permisos.Comandas
        },
        {
          icon: "ClipboardList",
          pageName: "pedidos",
          title: "Pedidos",
          permiso: Permisos.Pedidos
        },
        {
          icon: "Clock",
          pageName: "turnos",
          title: "Turnos",
          permiso: Permisos.Turnos
        },
        {
          icon: "LayoutGrid",
          pageName: "mesas",
          title: "Mesas",
          soloAdmin: true
        },
        {
          icon: "Box",
          pageName: "productos",
          title: "Productos",
          soloAdmin: true
        },
        {
          icon: "Users",
          pageName: "usuarios",
          title: "Usuarios",
          soloAdmin: true
        },
        {
          icon: "Settings",
          pageName: "opcionesGenerales",
          title: "Opciones",
          soloAdmin: true
        },
        {
          icon: "FileText",
          pageName: "logAcciones",
          title: "Log acciones",
          soloMailsInternos: true
        },
        {
          icon: "ChartNoAxesColumnIncreasing",
          pageName: "estadisticas",
          title: "Estadísticas",
          soloAdmin: true
        }
      ];

      const menu = menuTodos.filter(item => {
        if (typeof item === "string") return true;
        if (item.soloMailsInternos) return puedeVerLogAccionesInterno();
        if (item.soloAdmin) return isAdmin();
        if (item.permiso) return puedeAccederModulo(item.permiso);
        return false;
      }) as Array<Menu | "divider">;

      this.menu = menu;
    }
  }
});
